import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { intercom, useUser } from 'libs';

const IntercomUpdate = (): null => {
  const location = useLocation();
  const user = useUser();

  useEffect(() => {
    intercom.update({ email: user.email });
  }, [location.pathname, location.search, location.hash, user.email]);

  return null;
};

export default IntercomUpdate;
